import { Navigate } from 'react-router-dom';
import { useSession } from '../useSession';
import { ROUTES } from '../../lib/constants';
import { PrivateRouteProps } from './PrivateRoute.types';

const PrivateRoute = ({ allowedRoles, children }: PrivateRouteProps) => {
  const { userInfo, userRole } = useSession();

  if (!userInfo) return <Navigate to={ROUTES.LOGIN} />;

  if (!allowedRoles || allowedRoles.length === 0) return <>{children}</>;

  if (userRole && !allowedRoles.includes(userRole)) {
    return <Navigate to={ROUTES.LOGIN} />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
